import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type loginFooterContentDetailsInitialStateType = {
  loginFooterPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: loginFooterContentDetailsInitialStateType = {
  loginFooterPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'am-login-footer.json'

export const getLoginFooterPageContent = createAsyncThunk(
  "get/loginFooter-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const loginFooterContentDetailSlice = createSlice({
  name: "loginFooter-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLoginFooterPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLoginFooterPageContent.fulfilled, (state, action) => {
      state.loginFooterPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getLoginFooterPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "login footer AEM Content",
        action.error?.message,
        action?.type
      );
      state.loginFooterPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default loginFooterContentDetailSlice.reducer;